import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.to-string.js";
var ANNOUNCEMENTS_QUERY_KEY = 'announcements';
var announcementKeys = {
  announcements: [ANNOUNCEMENTS_QUERY_KEY],
  singleAnnouncement: function singleAnnouncement(announcementId) {
    return [ANNOUNCEMENTS_QUERY_KEY, announcementId];
  },
  announcementsList: function announcementsList(limit, page) {
    return [ANNOUNCEMENTS_QUERY_KEY, 'list', limit, page].filter(Boolean);
  }
};
export default announcementKeys;